import { useContext } from 'react';

import { ChainlitContext } from '@chainlit/react-client';

import { Button } from '@/components/ui/button';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger
} from '@/components/ui/tooltip';

export interface ButtonLinkProps {
  name?: string;
  displayName?: string;
  iconUrl?: string;
  url: string;
  target?: '_blank' | '_self' | '_parent' | '_top';
}

export default function ButtonLink({
  name,
  displayName,
  iconUrl,
  url,
  target
}: ButtonLinkProps) {
  const apiClient = useContext(ChainlitContext);

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant="ghost"
            size={displayName ? 'default' : 'icon'}
            className={displayName ? 'text-muted-foreground hover:text-muted-foreground' : 'rounded-full text-muted-foreground hover:bg-muted/50 hover:text-muted-foreground'}
          >
            <a
              href={url}
              target={target ?? '_blank'}
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1"
            >
              <img
                src={
                  iconUrl?.startsWith('/public')
                    ? apiClient.buildEndpoint(iconUrl)
                    : iconUrl
                }
                className={'h-6 w-6'}
                alt={name}
              />
              {displayName && <span>{displayName}</span>}
            </a>
          </Button>
        </TooltipTrigger>
        <TooltipContent>{name}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
